<template>
	<transition
		name="modal-drop-fade"
		appear
		appear-active-class="modal-drop-fade-enter-active"
	>
		<section class="modal">
			<div class="modal-dialog">
				<div class="modal-wrapper">
					<slot name="modalHeader" v-if="showHeader">
						<header class="modal-header">
							<span
								class="modal-title b360-handle-overflow"
								role="heading"
								:title="
									truncateModalFields({
										fieldName: title,
										fieldLength: 36,
										attributeName: 'title',
									})
								"
							>
								{{
									truncateModalFields({
										fieldName: title,
										fieldLength: 36,
									})
								}}
							</span>
							<span
								class="modal-close-btn"
								v-if="showClose"
								aria-label="Close Modal"
								role="button"
								@click="$emit('close')"
							>
								<font-awesome-icon :icon="['fal', 'times']" />
							</span>
						</header>
					</slot>
					<slot name="modalBody" />
					<footer v-if="showFooter" class="modal-footer">
						<slot name="modalFooterButtons" />
					</footer>
				</div>
			</div>
		</section>
	</transition>
</template>

<script>
import { truncateModalFields } from '@/views/client-connect-v2/helpers';

export default {
	name: 'BaseModal',
	props: {
		modalTitle: {
			type: String,
			default: '',
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showFooter: {
			type: Boolean,
			default: true,
		},
		showClose: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		title() {
			if (this.modalTitle === 'undefined undefined') {
				return '';
			} else {
				return this.modalTitle;
			}
		},
	},
	methods: {
		truncateModalFields,
	},
};
</script>

<style lang="scss" scoped>
.modal {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba($black, 0.5);
	display: block;
	margin-top: 0;
	overflow-y: auto;

	&-dialog {
		display: block;
		top: 50px;
		width: 90%;
		height: 100%;
		max-width: 600px;
		position: relative;
		margin: 0 auto;
	}

	&-wrapper {
		background: $off-white;
		border-radius: 6px;
		width: 100%;
	}

	&-header {
		background: $white;
		color: $black;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid $border-color-light;
		line-height: 1;
		@include rem('padding', 18px 20px);
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
	}

	&-title {
		font-weight: 600;
		@include rem('font-size', 18px);
	}

	&-close-btn {
		@include rem('font-size', 22px);
		cursor: pointer;
	}

	&-footer {
		border-top: 1px solid $border-color-light;
		@include rem('padding', 15px 20px);
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
	}
}

.modal-drop-fade-enter,
.modal-drop-fade-leave-active {
	opacity: 0;
}

.modal-drop-fade-enter .modal-dialog,
.modal-drop-fade-leave-active .modal-dialog {
	transform: translate(0, -50px);
	opacity: 0;
}

.modal-drop-fade-enter-active,
.modal-drop-fade-leave-active {
	transition: opacity 0.5s ease;
}

.modal-drop-fade-enter-active .modal-dialog,
.modal-drop-fade-leave-active .modal-dialog {
	transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}
</style>
